export const CASE_ORDERS = 'CASE_ORDERS';
export const OR_REQUESTS = 'OR_REQUESTS';
//export const WEB_SOCKET_STATUS = 'WEB_SOCKET_STATUS';